import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../layouts/default";
import BGImageHero from "../sections/BGImageHero";
import Manifesto from "../sections/Manifesto";
import Statement from "../sections/Statement";
import StoryGrid from "../sections/StoryGrid";
import FaqSection from "../sections/FaqSection";
import richText from "../utils/richText";
import KaramoVideo from "../sections/KaramoVideo";

export const query = graphql`
  {
    contentfulAboutOurStory {
      backgroundHero {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      missionStatement {
        raw
      }
      manifestoHeadline
      manifestChoices
      manifestoBody {
        raw
      }
      manifestoImageGrid {
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      faqs {
        answer {
          raw
        }
        question {
          question
        }
      }
    }
    contentfulKaramoLandingPage {
      journeyVideoYoutubeId
      videoPlaceholder {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  }
`;

export default function OurStory({ data, location }) {
  const ourStory = data.contentfulAboutOurStory;

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>Our Story</title>
      </Helmet>
      <BGImageHero text="Our Story" image={ourStory.backgroundHero.fluid} />
      <Statement
        header="Our Mission"
        text={richText(ourStory.missionStatement.raw)}
      />
      <Manifesto
        headline={ourStory.manifestoHeadline}
        choices={ourStory.manifestChoices}
        body={ourStory.manifestoBody.raw}
      />
      <StoryGrid images={ourStory.manifestoImageGrid} />
      {ourStory.faqs.length > 0 && <FaqSection faqs={ourStory.faqs} />}
      <KaramoVideo
        id={data.contentfulKaramoLandingPage.journeyVideoYoutubeId}
        placeholder={data.contentfulKaramoLandingPage.videoPlaceholder}
      />
    </Layout>
  );
}
